<template>
  <b-modal id="partialCancelDetail" size="lg" ref="partialCancelDetail" title="부분취소신청">
    <b-row class="text-center">
      <b-col cols="2"></b-col>
      <b-col cols="8">
        <b-form-group no-gutters>
          <b-form-checkbox-group
            id="btn-radios-2"
            stacked
            buttons
            button-variant="outline-primary default"
            name="radio-btn-outline"
          >
            <b-form-checkbox
              v-model="selectedPartialCancelCoupons"
              v-for="(option ,index) in data"
              :key="index"
              :value="option.value"
              class="mt-2"
            >{{option.text}}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
      <b-col cols="2"></b-col>
    </b-row>
    <b-row>
      <b-col cols="2"></b-col>
      <b-col cols="8">환불금액 : {{selectedPartialPrice | currency }} 원</b-col>
      <b-col cols="2"></b-col>
    </b-row>
    <template slot="modal-footer">
      <b-button variant="primary" @click="partialCancel">부분취소</b-button>
      <b-button variant="outline-primary" @click="partialModalHide">닫기</b-button>
    </template>
  </b-modal>
</template>
<script>
  import {currencyFilter} from "../../../utils";

  export default {
    name : "PartialCancelDetail" ,
    props : ['data'] ,
    filters : {...currencyFilter},
    data() {
      return {
        selectedPartialPrice: 0,
        selectedPartialCancelCoupons : [] ,
      }
    },
    mounted() {

    },
    watch : {
      selectedPartialCancelCoupons( value ){
        let totalPrice = 0;
        value.forEach((v)=>{
          totalPrice += Number(v.price)
        })
        this.selectedPartialPrice = totalPrice
      }
    },
    methods: {
      open(){
        this.$refs['partialCancelDetail'].show()
      },
      partialCancel(){
        if( this.selectedPartialCancelCoupons.length == 0 ) {
          alert('부분 취소 신청할 옵션을 선택해주세요.')
          return false
        }
        this.$emit('process' , this.selectedPartialCancelCoupons)
      },
      partialModalHide(){
        this.$refs['partialCancelDetail'].hide()
      }
    }
  }
</script>
